var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("ขอบคุณที่ใช้บริการเรา")]),_vm._v(" "),_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("กรุณา Login")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-382e06ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome/ManageShop.vue
// module id = null
// module chunks = 